export const BLOCK_CHANNEL_INIT = 'BLOCK_CHANNEL_INIT';
export const BLOCK_CHANNEL_SUCCESS = 'BLOCK_CHANNEL_SUCCESS';
export const BLOCK_CHANNEL_ERROR = 'BLOCK_CHANNEL_ERROR';

export const UNBLOCK_CHANNEL_INIT = 'UNBLOCK_CHANNEL_INIT';
export const UNBLOCK_CHANNEL_SUCCESS = 'UNBLOCK_CHANNEL_SUCCESS';
export const UNBLOCK_CHANNEL_ERROR = 'UNBLOCK_CHANNEL_ERROR';

export const GET_STATUS_CONTROL_PIN_INIT = 'GET_STATUS_CONTROL_PIN_INIT';
export const GET_STATUS_CONTROL_PIN_SUCCESS = 'GET_STATUS_CONTROL_PIN_SUCCESS';
export const GET_STATUS_CONTROL_PIN_ERROR = 'GET_STATUS_CONTROL_PIN_ERROR';
export const CLEAR_STATUS_CONTROL_PIN = 'CLEAR_STATUS_CONTROL_PIN';

export const ACTIVATE_CHANNEL_PIN_INIT = 'ACTIVATE_CHANNEL_PIN_INIT';
export const ACTIVATE_CHANNEL_PIN_SUCCESS = 'ACTIVATE_CHANNEL_PIN_SUCCESS';
export const ACTIVATE_CHANNEL_PIN_ERROR = 'ACTIVATE_CHANNEL_PIN_ERROR';
export const ACTIVATE_CHANNEL_PIN_CLEAR = 'ACTIVATE_CHANNEL_PIN_CLEAR';

export const ACTIVATE_CONTROL_PIN_INIT = 'ACTIVATE_CONTROL_PIN_INIT';
export const ACTIVATE_CONTROL_PIN_SUCCESS = 'ACTIVATE_CONTROL_PIN_SUCCESS';
export const ACTIVATE_CONTROL_PIN_ERROR = 'ACTIVATE_CONTROL_PIN_ERROR';

export const CHECK_CONTROL_PIN_INIT = 'CHECK_CONTROL_PIN_INIT';
export const CHECK_CONTROL_PIN_SUCCESS = 'CHECK_CONTROL_PIN_SUCCESS';
export const CHECK_CONTROL_PIN_ERROR = 'CHECK_CONTROL_PIN_ERROR';
export const CLEAR_CHECK_CONTROL_PIN = 'CLEAR_CHECK_CONTROL_PIN';

export const REMIND_CONTROL_PIN_INIT = 'REMIND_CONTROL_PIN_INIT';
export const REMIND_CONTROL_PIN_SUCCESS = 'REMIND_CONTROL_PIN_SUCCESS';
export const REMIND_CONTROL_PIN_ERROR = 'REMIND_CONTROL_PIN_ERROR';

export const UNLOCK_CONTENT_TEMPORARILY = 'UNLOCK_CONTENT_TEMPORARILY';
export const CLEAR_TEMPORARILY_UNLOCKED_CONTENT =
  'CLEAR_TEMPORARILY_UNLOCKED_CONTENT';
